import CopilotActionButton from './actionButtons/CopilotActionButton';
import LinkActionButton from './actionButtons/LinkActionButton';
import TemplateActionButton from './actionButtons/TemplateActionButton';
import CopilotActionButtonV2 from './actionButtons/CopilotActionButtonV2';
import { ActionButtonTypename, ActionButtonV2Typename, BreezeActionButtonTypename, LinkButtonTypename, TemplateButtonTypename } from 'chatspot-core/__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotMessageService';
import { BreezeActionButton } from './actionButtons/BreezeActionButton';
import { jsx as _jsx } from "react/jsx-runtime";
const SectionActionButton = ({
  disabled,
  inDataTable = false,
  messageAction,
  size = 'xs',
  use,
  eventName,
  eventProperties,
  usageTracker,
  usageTrackerLocation,
  tooltip
}) => {
  const buttonUse = use !== null && use !== void 0 ? use : messageAction.buttonUse;
  if (messageAction.__typename === BreezeActionButtonTypename) {
    return /*#__PURE__*/_jsx(BreezeActionButton, {
      props: {
        disabled,
        use: buttonUse
      },
      tooltip: tooltip,
      breezeActionButton: messageAction
    });
  } else if (messageAction.__typename === ActionButtonTypename) {
    return /*#__PURE__*/_jsx(CopilotActionButton, {
      disabled: disabled,
      copilotActionButton: messageAction,
      inDataTable: inDataTable,
      size: size,
      use: buttonUse,
      tooltip: tooltip
    });
  } else if (messageAction.__typename === ActionButtonV2Typename) {
    return /*#__PURE__*/_jsx(CopilotActionButtonV2, {
      disabled: disabled,
      chatspotActionButton: messageAction,
      inDataTable: inDataTable,
      size: size,
      eventName: eventName,
      eventProperties: eventProperties,
      usageTracker: usageTracker,
      usageTrackerLocation: usageTrackerLocation,
      use: buttonUse,
      tooltip: tooltip
    });
  } else if (messageAction.__typename === LinkButtonTypename) {
    return /*#__PURE__*/_jsx(LinkActionButton, {
      disabled: disabled,
      inDataTable: inDataTable,
      linkActionButton: messageAction,
      size: size,
      use: buttonUse,
      tooltip: tooltip
    });
  } else if (messageAction.__typename === TemplateButtonTypename) {
    return /*#__PURE__*/_jsx(TemplateActionButton, {
      disabled: disabled,
      inDataTable: inDataTable,
      templateActionButton: messageAction,
      size: size,
      use: buttonUse,
      tooltip: tooltip
    });
  }
  return null;
};
export default SectionActionButton;